const isString = (input: unknown): input is string => {
  return typeof input === "string";
};

export default isString;
